import { FC } from 'react'

import { ISvgClass } from '../interface'

const WhatsappIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="inherit" // Alterando o fill para "inherit"
        d="M19 4.91006C18.0832 3.98399 16.9912 3.24973 15.7876 2.75011C14.5841 2.25049 13.2931 1.99552 11.99 2.00006C6.53 2.00006 2.08 6.45006 2.08 11.9101C2.08 13.6601 2.54 15.3601 3.4 16.8601L2 22.0001L7.25 20.6201C8.7 21.4101 10.33 21.8301 11.99 21.8301C17.45 21.8301 21.9 17.3801 21.9 11.9201C21.9 9.27006 20.87 6.78006 19 4.91006ZM11.99 20.1501C10.51 20.1501 9.06 19.7501 7.79 19.0001L7.49 18.8201L4.37 19.6401L5.2 16.6001L5 16.2901C4.17775 14.977 3.74114 13.4593 3.74 11.9101C3.74 7.37006 7.44 3.67006 11.98 3.67006C14.18 3.67006 16.25 4.53006 17.8 6.09006C18.5675 6.85402 19.1757 7.76272 19.5894 8.76348C20.0031 9.76425 20.214 10.8372 20.21 11.9201C20.23 16.4601 16.53 20.1501 11.99 20.1501ZM16.51 13.9901C16.26 13.8701 15.04 13.2701 14.82 13.1801C14.59 13.1001 14.43 13.0601 14.26 13.3001C14.09 13.5501 13.62 14.1101 13.48 14.2701C13.34 14.4401 13.19 14.4601 12.94 14.3301C12.69 14.2101 11.89 13.9401 10.95 13.1001C10.21 12.4401 9.72 11.6301 9.57 11.3801C9.43 11.1301 9.55 11.0001 9.68 10.8701C9.79 10.7601 9.93 10.5801 10.05 10.4401C10.17 10.3001 10.22 10.1901 10.3 10.0301C10.38 9.86006 10.34 9.72006 10.28 9.60006C10.22 9.48006 9.72 8.26006 9.52 7.76006C9.32 7.28006 9.11 7.34006 8.96 7.33006H8.48C8.31 7.33006 8.05 7.39006 7.82 7.64006C7.6 7.89006 6.96 8.49006 6.96 9.71006C6.96 10.9301 7.85 12.1101 7.97 12.2701C8.09 12.4401 9.72 14.9401 12.2 16.0101C12.79 16.2701 13.25 16.4201 13.61 16.5301C14.2 16.7201 14.74 16.6901 15.17 16.6301C15.65 16.5601 16.64 16.0301 16.84 15.4501C17.05 14.8701 17.05 14.3801 16.98 14.2701C16.91 14.1601 16.76 14.1101 16.51 13.9901Z"
      />
    </svg>
  )
}

export default WhatsappIcon
